import React, { useRef, useState } from 'react';
import {Box, IconButton, List, ListItem, ListItemText, Menu, MenuItem, Stack} from '@mui/material';
import {NavMenuDivider, NavMenuListItem} from "./NavMenuListItem";
import {useTheme} from "@mui/material/styles";

const HamburgerToXButton = () => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  return (
    <div
      ref={anchorRef}
      onClick={() => setOpen(!open)}
      style={{ display: 'inline-block' }}
    >
      <IconButton
        sx={{
          cursor: 'pointer',
          width: '40px',
          height: '40px',
        }}
      >
        <Stack spacing={0.5}>
          <span
            style={{
              ...lineStyle(),
              transform: open
                ? 'rotate(45deg) translate(5px, 5px)'
                : 'rotate(0deg)',
            }}
          />
          <span
            style={{
              ...lineStyle(),
              opacity: open ? 0 : 1,
            }}
          />
          <span
            style={{
              ...lineStyle(),
              transform: open
                ? 'rotate(-45deg) translate(5px, -5px)'
                : 'rotate(0deg)',
            }}
          />
        </Stack>
      </IconButton>

      <Menu
        anchorEl={anchorRef.current}
        open={open}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        MenuListProps={{
          disablePadding: true,
        }}
        PaperProps={{
          sx: {
            zIndex: 1200,
            minWidth: '300px',
            maxHeight: '92vh',
            overflow: 'auto',
            borderRadius: '4px',
          },
        }}
      >
        <List disablePadding>
          <NavMenuDivider title={'TOOLS'}/>
          <Box sx={{padding: 1}}>
            <NavMenuListItem linkTo={'/mhdweb2/tools/plot1d'} text={"Plot1D"}/>
            <NavMenuListItem linkTo={'/mhdweb2/tools/plot2d'} text={"Plot2D"}/>
            <NavMenuListItem linkTo={'/mhdweb2/tools/data-products'} text={"Coronal Hole Maps"}/>
            <NavMenuListItem linkTo={'/mhdweb2/tools/time-series'} text={"Time Series"}/>
            <NavMenuListItem linkTo={'/mhdweb2/tools/spacecraft-mapping'} text={"Spacecraft Mapping"}/>
            <NavMenuListItem linkTo={'/mhdweb2/tools/white-light'} text={"White Light"}/>
            <NavMenuListItem linkTo={'/mhdweb2/tools/coronagraphs'} text={"Coronagraphs"}/>
            <NavMenuListItem linkTo={'/mhdweb2/tools/euv'} text={"EUV & X-Rays"}/>
            <NavMenuListItem linkTo={'/mhdweb2/tools/euv-comparison'} text={"EUV Imagers"}/>
            <NavMenuListItem linkTo={'/mhdweb2/tools/data-access'} text={"Data Access"}/>
          </Box>
          <NavMenuDivider title={'RESOURCES'}/>
          <Box sx={{padding: 1}}>
            <NavMenuListItem linkTo={'https://www.predsci.com/portal/home.php'} text={"PSI"}/>
            <NavMenuListItem linkTo={'/mhdweb2/api'} text={"API"}/>
            <NavMenuListItem linkTo={'/mhdweb2/about'} text={"About"}/>
            <NavMenuListItem linkTo={'/mhdweb2/references'} text={"References"}/>
            <NavMenuListItem linkTo={'https://www.predsci.com/portal/contact.php'} text={"Contact Us"}/>
          </Box>
        </List>
      </Menu>
    </div>
  );
};

const lineStyle = () => ({
  display: 'block',
  height: '2px',
  width: '24px',
  backgroundColor: '#fefefe',
  margin: '2.5px 0',
  transition: 'all 0.3s ease',
  transformOrigin: 'center',
});

export default HamburgerToXButton;
